module.exports = __webpack_public_path__ + "164ca2affd9fa9fc01d22937c9493894.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-28.png
// module id = 1798
// module chunks = 0